export const ru = {
    adjustmentsRate:
        'Могут быть применены корректировки ставок от {minValue}% до {maxValue}%',
    emptyMessage: 'Введите значение',
    gteCpmBannerMessage: 'Ставка должна быть не больше {maxValue}',
    gteCpmBannerMessageWithCurrency:
        'Ставка должна быть не больше {maxValue} {currency}',
    gteMessage: 'Цена за клик выше максимально возможного значения {maxValue}',
    gteMessageWithCurrency:
        'Цена за клик выше максимально возможного значения {maxValue} {currency} ',
    lteCpmBannerMessage: 'Ставка должна быть не меньше {minValue}',
    lteCpmBannerMessageWithCurrency:
        'Ставка должна быть не меньше {minValue} {currency}',
    lteMessage: 'Цена за клик ниже минимально возможного значения {minValue}',
    lteMessageWithCurrency:
        'Цена за клик ниже минимально возможного значения {minValue} {currency}',
    nanCpmBannerMessage: 'Ставка должна быть числом',
    nanMessage: 'Цена за клик должна быть числом'
};
